import { fetcher, AdminStreaksEndpoints } from "@olagg/api-hooks";
import { useState } from "react";

const useStreaks = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [streaks, setStreaks] = useState<any>([]);
  const [count, setCount] = useState<any>(0);

  const getAllStreaks = async () => {
    setIsLoading(true);
    try {
      const response = await fetcher(AdminStreaksEndpoints.all());
      const { streakCampaigns, meta } = response
      setStreaks(streakCampaigns)
      setCount(meta?.count || 1)
    } catch (error: any) {
      console.error("EL ERROR", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    setIsLoading,
    getAllStreaks,
    streaks,
    count
  }
}

export default useStreaks;
